module.exports = __webpack_public_path__ + "img/cp55_top.4b3371db.png";